import clsx from "clsx";
import styles from "./index.module.scss";
import Icon from "../../../common/icon";

export default function Sert({ sert, isBaltex = false, isLanding = false }) {
  return sert?.length > 0 ? (
    <div className={clsx(isLanding && styles.SertLanding)}>
      {sert.map((item) => (
        <div className={styles.Files} key={item.NAME}>
          <a
            href={item.URL}
            className={styles.File}
            rel="noreferrer"
            target="_blank"
          >
            {isLanding && <Icon id="download" width={18} height={20} />}
            {isBaltex && <Icon id="baltexpdf" width={18} height={20} />}
            {!isLanding && !isBaltex && (
              <svg
                width="16"
                height="22"
                viewBox="0 0 16 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.96668 13.7219L3 21L7.5884 18.247C7.73805 18.1572 7.81288 18.1123 7.89276 18.0947C7.96341 18.0792 8.03659 18.0792 8.10724 18.0947C8.18712 18.1123 8.26195 18.1572 8.4116 18.247L13 21L12.0343 13.7212M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z"
                  stroke="#1247A5"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
            <div className={styles.Name}>
              <div>{item.NAME}</div>
            </div>
          </a>
        </div>
      ))}
    </div>
  ) : null;
}
